import {Upload, type UploadState} from 'upload'
import {type Memory} from './memory.server'

export const getTxmUploader = ({
  id,
  file,
  onProgressChange,
  onStateChange,
  licenseKey,
}: {
  id: Memory['id']
  file: File
  onProgressChange?: (progress: number) => void
  onStateChange?: (state: UploadState) => void
  licenseKey: string
}) => {
  const formData = new FormData()
  formData.append('tmx', file)

  const upload = new Upload({
    url: `${window.ENV.MMT_TRANSLATE_API_EU_URL}/memories/${id}/content`,
    form: formData,
    headers: {'MMT-ApiKey': licenseKey},
  })

  upload.on('progress', (progress) => onProgressChange?.(progress))
  upload.on('state', (state) => onStateChange?.(state))

  return upload
}
